<template>
  <v-container>
    <h4 class="text-center mt-3">Color del borde</h4>
    <koiote-color-picker-vue
      class="mt-2"
      :pcolor="selectedItem.customized.border_color"
      @event="changeBorderColor"
    ></koiote-color-picker-vue>

    <h4 class="text-center mt-5">Propiedades</h4>

    <v-text-field
      prefix="Dirección PLC:"
      class="ml-3 mr-3 mb-5"
      v-model="selectedItem.customized.address"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.customized.address == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
      @blur="updateEditing(false)"
    />

    <v-label class="ml-3"> Valor actual: {{ value }} </v-label>

    <h4 class="text-center mt-6">Imágenes</h4>
    <div
      class="mt-5 pb-2"
      style="background-color: #f5f5f5; border-radius: 5px; display: flex; flex-direction: column; align-items: center"
    >
      <v-btn
        class="ma-2 mt-4"
        width="90%"
        @click="toggleShowStaticImage"
      >
        Imagen estática
      </v-btn>
      <v-file-input
        v-if="show_static_image"
        class="mt-4"
        accept="image/*"
        dense
        background-color="white"
        v-model="static_image_file"
        @change="fileChangedInItemWithoutPLC($event)"
      >
        <template v-slot:selection>
          <v-img
            class="ml-2 mr-2"
            :src="selectedItem.customized.static_image"
            contain
            height="20px"
            width="80px"
          >
          </v-img>
        </template>
      </v-file-input>
    </div>
    <div
      class="mt-5 pb-2"
      style="background-color: #f5f5f5; border-radius: 5px; display: flex; flex-direction: column; align-items: center"
    >
      <v-btn
        class="ma-2 mt-4"
        width="90%"
        @click="toggleShowValues"
      >
        Imágenes Dinámicas
      </v-btn>
      <v-simple-table
        v-if="show_values"
        class="ma-3"
      >
        <template v-slot:default>
          <thead>
            <tr>
              <th>Valor</th>
              <th>Imagen</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in selectedItem.customized.values"
              :key="index"
            >
              <td>{{ item }}</td>
              <td>
                <v-file-input
                  accept="image/*"
                  dense
                  v-model="dynamic_image_files[index]"
                  @change="fileChangedInItem(item, $event)"
                >
                  <template v-slot:selection>
                    <v-img
                      :src="getSelectedImage(item)"
                      contain
                      height="32px"
                      width="32px"
                    ></v-img> </template
                ></v-file-input>
              </td>
            </tr>
            <tr>
              <td>
                <v-text-field
                  @keyup.enter="saveValue"
                  v-model="new_value"
                ></v-text-field>
              </td>
              <td></td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import KoioteColorPickerVue from "@/components/utils/KoioteColorPicker.vue";

export default {
  name: "KoioteImageSwitchCanvasProperties",

  components: {
    KoioteColorPickerVue,
  },

  data() {
    return {
      show_static_image: true,
      show_values: false,
      new_value: null,
      static_image_file: {},
      dynamic_image_files: [],
    };
  },

  computed: {
    ...mapState(["selectedItem"]),

    value() {
      const retrievedValue = this.actualPage()
        .global_item_list.find((gi) => gi.settings.component_type.includes("connection"))
        .customized.vartable.find((v) => v.formatted_address == this.selectedItem.customized.address)?.value;
      const applicableRetrievedValue = retrievedValue == null || isNaN(retrievedValue) ? 0 : retrievedValue;
      return typeof applicableRetrievedValue === "boolean" ? +applicableRetrievedValue : applicableRetrievedValue;
    },
  },

  methods: {
    ...mapGetters(["actualPage"]),
    ...mapActions(["updateEditing"]),

    changeBorderColor(nc) {
      this.selectedItem.customized.border_color = nc;
    },

    fileChangedInItemWithoutPLC(e) {
      if (e != null) {
        const reader = new FileReader();
        reader.onload = async (event) => {
          this.selectedItem.customized.ignore_plc = true;
          this.selectedItem.customized.static_image = event.target.result;
        };
        reader.readAsDataURL(e);
      } else {
        this.selectedItem.customized.static_image = null;
        this.selectedItem.customized.ignore_plc = false;
      }
    },

    fileChangedInItem(it, e) {
      if (e != null) {
        const reader = new FileReader();
        reader.onload = (event) => {
          //si ya existe imagen para ese valor, la reemplaza
          if (this.selectedItem.customized.set_values.includes(it)) {
            this.selectedItem.customized.images[this.selectedItem.customized.set_values.indexOf(it)] =
              event.target.result;
          } else {
            //si no existe, la agrega
            this.selectedItem.customized.images.push(event.target.result);
            this.selectedItem.customized.set_values.push(it);
            this.dynamic_image_files.splice(this.dynamic_image_files.length, 0, {});
          }
          this.selectedItem.customized.images.splice();
          this.selectedItem.customized.set_values.splice();
        };

        reader.readAsDataURL(e);
      } else {
        // si se borra la imagen
        if (this.selectedItem.customized.set_values.includes(this.value)) {
          this.selectedItem.customized.images.splice(this.selectedItem.customized.set_values.indexOf(this.value), 1);
          this.selectedItem.customized.set_values.splice(
            this.selectedItem.customized.set_values.indexOf(this.value),
            1
          );
        }
      }
    },

    getSelectedImage(value) {
      if (this.selectedItem.customized.set_values.includes(value)) {
        return this.selectedItem.customized.images[this.selectedItem.customized.set_values.indexOf(value)];
      }
    },

    toggleShowStaticImage() {
      this.show_static_image = !this.show_static_image;
    },

    toggleShowValues() {
      this.show_values = !this.show_values;
    },

    saveValue() {
      if (!this.selectedItem.customized.values.includes(this.new_value)) {
        this.selectedItem.customized.values.push(this.new_value);
      }
      this.new_value = null;
    },
  },

  mounted() {
    this.dynamic_image_files = new Array(this.selectedItem.customized.values.length).fill({});
  },
};
</script>
